module.exports = {
  active: {
    label: 'Active',
    key: 'active',
  },
  pending: {
    label: 'Pending',
    key: 'pending',
  },
  deleted: {
    label: 'Deleted',
    key: 'deleted',
  },
  archive: {
    label: 'Archived',
    key: 'archive',
  },
  history: {
    label: 'History',
    key: 'history',
  },
};